import { render, staticRenderFns } from "./placeUpdateAndAddDialog.vue?vue&type=template&id=0504fb7b&scoped=true&"
import script from "./placeUpdateAndAddDialog.vue?vue&type=script&lang=js&"
export * from "./placeUpdateAndAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./placeUpdateAndAddDialog.vue?vue&type=style&index=0&id=0504fb7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504fb7b",
  null
  
)

export default component.exports